import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import Secret from "components/secrets/Secret";
import Breadcrumbs from "components/common/Breadcrumbs";
import { useMemberDetails } from "components/context/MemberDetailsContext";

export default () => {
  const { data } = useMemberDetails();
  const navigate = useNavigate();
  const { secretRef } = useParams();
  const onSaveHandler = () => {
    navigate(`/secrets`);
  };
  const onCancelHandler = () => {
    navigate(`/secrets`);
  };

  return (
    <Box>
      <Box sx={{ marginTop: "32px", marginLeft: "24px" }}>
        <Breadcrumbs breadcrumbs={[{ name: "Secrets" }]} />
      </Box>
      <Secret
        secretRef={secretRef || ""}
        onSaveHandler={onSaveHandler}
        onCancelHandler={onCancelHandler}
        family={data?.family}
      />
    </Box>
  );
};
